import Dashboard from "@/pages/dashboard/DashboardPage.vue";
export default [
  {
    path: "/dashboard",
    component: Dashboard,
  },
  {
    path: "/export-data/",
    component: () => import("@/pages/export-data/export-data-list.vue"),
    meta: {
      requiredLevel: ["admin", "kelurahan"],
    },
  },
];
